var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.menuVisible,
          expression: "menuVisible",
        },
      ],
      staticClass: "menu",
      attrs: { id: "contextmenu" },
    },
    [
      _vm.configData.type === 1
        ? _c("div", { staticClass: "right-item-list" }, [
            _c(
              "div",
              {
                staticClass: "right-item",
                on: {
                  click: function ($event) {
                    return _vm.rightItemClick()
                  },
                },
              },
              [_vm._v("设置职级")]
            ),
            _vm._v(" "),
            _vm.configData.value
              ? _c(
                  "div",
                  {
                    staticClass: "right-item",
                    on: {
                      click: function ($event) {
                        return _vm.deleteRankItem()
                      },
                    },
                  },
                  [_vm._v("移除职级")]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.configData.type === 2
        ? _c(
            "div",
            { staticClass: "right-item-list" },
            _vm._l(_vm.configData.tableData, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "right-item",
                  class: _vm.configData.value === item.alias ? "active" : "",
                  on: {
                    click: function ($event) {
                      return _vm.rankItemClick(item)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(item.alias) + "\n    ")]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }